import { queryOptions } from '@tanstack/react-query'
import { reads } from '../admin/api'
import { currentUserQuery } from '../admin/queries'

export { currentUserQuery as meQuery }

export const notificationPrefsQuery = () =>
  queryOptions({
    queryKey: ['me', 'notifications'],
    queryFn: () => reads().notifications(),
  })
